import Vue from 'vue'
import Router from 'vue-router'
import pay from '@/components/pay'
import index from '@/components/index'
import about from '@/components/about'
import game from '@/components/game'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/game',
      name: 'game',
      component: game
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js